import { render, staticRenderFns } from "./Cooperation.vue?vue&type=template&id=2bffd4ac&scoped=true"
import script from "./Cooperation.vue?vue&type=script&lang=js"
export * from "./Cooperation.vue?vue&type=script&lang=js"
import style0 from "./Cooperation.vue?vue&type=style&index=0&id=2bffd4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bffd4ac",
  null
  
)

export default component.exports